import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import {atomIconSizes} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import Helmet from '@s-ui/react-head'
import Layout from '@adv-mt/mt-layout-basic'
import IconAngleLeft from '@adv-mt/mt-svg-icons/lib/AngleLeft.js'

import LinkFactory from '../../../components/LinkFactory/index.js'
import StepLanding from './components/steps/StepLanding/index.js'
import StepUserDataForm from './components/steps/StepUserDataForm/index.js'
import StepVehicleForm from './components/steps/StepVehicleForm/index.js'
import StepVehicleSelect from './components/steps/StepVehicleSelect/index.js'
import {useLandingInstantOffer} from './useLandingInstantOffer.js'

const LandingInstantOfferTest = ({helmet}) => {
  const {domain} = useContext(Context)

  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const {
    config: {STEPS},
    handlers: {
      handleClickConfirmVehicle,
      handleClickEditVehicleData,
      handleClickNotSellerVehicle,
      handleBackNavigation,
      handlePlateFormGetVehicles,
      handleUserDataFormSubmit,
      handleVehicleFormSubmit
    },
    state: {currentStep, makesList, sellerVehicle, vehicleList, vehicleFormOrigin}
  } = useLandingInstantOffer()

  return (
    <Layout.FullWidth
      topbarProps={{
        customContent: <></>,
        mainNavigationItems: [],
        showBrandIcon: isMobile,
        showNavUserOnDesktop: false,
        showToggleNavOnMobile: false,
        ...(currentStep !== STEPS.LANDING && {
          navButton: (
            <div className={`mt-Landing-InstantOffer-navButton`}>
              <AtomButton
                color="primary"
                design={atomButtonDesigns.FLAT}
                leftIcon={<IconAngleLeft size={atomIconSizes.large} />}
                link
                onClick={handleBackNavigation}
                shape={atomButtonShapes.CIRCULAR}
              />
            </div>
          )
        })
      }}
      linkFactory={LinkFactory}
      footerProps={{isSimple: true}}
    >
      <Helmet {...helmet} />
      {currentStep === STEPS.LANDING && (
        <StepLanding onGetVehicles={handlePlateFormGetVehicles} sellerVehicle={sellerVehicle} />
      )}
      {currentStep === STEPS.VEHICLE_SELECT && (
        <StepVehicleSelect
          onClickConfirmVehicle={handleClickConfirmVehicle}
          onClickEditVehicleData={handleClickEditVehicleData}
          onClickNotSellerVehicle={handleClickNotSellerVehicle}
          sellerVehicle={sellerVehicle}
          vehicleList={vehicleList}
        />
      )}
      {currentStep === STEPS.VEHICLE_FORM && (
        <StepVehicleForm
          makesList={makesList}
          onClickSubmit={handleVehicleFormSubmit}
          origin={vehicleFormOrigin}
          sellerVehicle={sellerVehicle}
        />
      )}
      {currentStep === STEPS.USER_FORM && (
        <StepUserDataForm onClickSubmit={handleUserDataFormSubmit} origin={vehicleFormOrigin} />
      )}
    </Layout.FullWidth>
  )
}

LandingInstantOfferTest.displayName = 'LandingInstantOfferTest'

LandingInstantOfferTest.getInitialProps = async ({context: {domain, i18n}}) => {
  const {LANDING_INSTANT_OFFER_TEST_PATTERN} = domain.get('config').get('page')
  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path: LANDING_INSTANT_OFFER_TEST_PATTERN})

  const [, getSeoDataResponse] = await domain.get('get_seo_data_use_case').execute({
    culture: i18n.culture,
    pageName
  })

  const initialData = {
    pageName,
    ...(getSeoDataResponse && {
      helmet: getSeoDataResponse.head || {}
    })
  }

  return initialData
}

LandingInstantOfferTest.propTypes = {
  helmet: PropTypes.object.isRequired
}

export default LandingInstantOfferTest
